import React from 'react';
import styles from './RichTextSection.module.css';
import sketchImg from '../../assets/SKETCHBG4.svg';

const RichTextSection = () => {
  return (
    <section className={styles.section}>

      {/* Sketch — right side, full height */}
      <img src={sketchImg} alt="" aria-hidden="true" className={styles.watermark} />

      <div className={styles.container}>
        <div className={styles.textBlock}>

          <span className={`${styles.quoteMark} ${styles.quoteLeft}`}>"</span>

          <span className={`${styles.line} ${styles.line1}`}>LOCALLY SOURCED GRAINS</span>
          <span className={`${styles.line} ${styles.line2}`}>CRAFTED INTO BREWS</span>

          <span className={`${styles.quoteMark} ${styles.quoteRight}`}>"</span>

        </div>
      </div>

    </section>
  );
};

export default RichTextSection;